/**
 * Hero 2023 block
 *
 * UI for handling the logic and animations of hero 2023 block
 */

const $ = require( 'jquery' );

var itblHero2023 = function(el){

  //setup some variables
  this.$el      = $(el);

  this.init();
};

itblHero2023.prototype.init = function(){

  this.events();

};

itblHero2023.prototype.events = function(){
  if(this.$el.hasClass('itbl-b-hero-2023--layout-5')) {
    $(document).on('scroll', this.event__handleScroll.bind(this));
  }

  // After 5 seconds, add the is-ready class if layout-2
  if(   !this.$el.hasClass('itbl-b-hero-2023--layout-2')
    &&  !this.$el.hasClass('itbl-b-hero-2023--layout-5')
    &&  !this.$el.hasClass('itbl-b-hero-2023--layout-4') ) {
    setTimeout(function(){
      this.$el.addClass('is-ready');
    }.bind(this), 5000);
  } else if(this.$el.hasClass('itbl-b-hero-2023--layout-4')) {
    setTimeout(function(){
      this.$el.addClass('is-ready');
    }.bind(this), 3000);
  } else if(this.$el.hasClass('itbl-b-hero-2023--layout-5')) {
    // disable scrolling
    if($(window).width() > 768) {
      $('body').css({'overflow': 'hidden', 'padding-right': '17px'});
    }

    setTimeout(function(){
      this.$el.addClass('is-ready');
    }.bind(this), 3000);

    if($(window).width() > 768) {
      setTimeout(function(){
        $('body').css({'overflow': 'auto', 'padding-right': '0px'});
      }, 6000);
    }
  } else {
    this.$el.addClass('is-ready');
  }

  window.focus();

  window.addEventListener('blur', function() {
    if (document.activeElement.tagName === "IFRAME") {
      $('.itbl-b-hero-2023__video-play-btn').css('z-index', '0');
    }
  });
};

itblHero2023.prototype.event__handleScroll = function(){
  var scroll = $(window).scrollTop();

  if(scroll > 0 && (!this.$el.hasClass('is-scrolled'))) {
    this.$el.addClass('is-scrolled');
    this.$el.removeClass('reverse-animation');

    if(!this.$el.hasClass('is-ready')) {
      // disable scrolling
      $('body').css({'overflow': 'hidden', 'padding-right': '17px'});

      // enable scrolling after 3 seconds
      setTimeout(function(){
        $('body').css({'overflow': 'auto', 'padding-right': '0px'});
      }.bind(this), 3000);
    }
  } else if(scroll === 0 && this.$el.hasClass('is-scrolled')) {
    this.$el.removeClass('is-scrolled');
    this.$el.removeClass('is-ready');
    this.$el.addClass('reverse-animation');

    // disable scrolling
    $('body').css({'overflow': 'hidden', 'padding-right': '17px'});

    // enable scrolling after 3 seconds
    setTimeout(function(){
      $('body').css({'overflow': 'auto', 'padding-right': '0px'});
    }.bind(this), 3000);
  }
}

$(function(){
  $('.itbl-b-hero-2023').each(function(){
    new itblHero2023(this);
  });
});
